export const calculateItemDragPosition = (
  item,
  initialOffset,
  currentOffset,
) => ({
  x: item.x + (currentOffset.x - initialOffset.x),
  y: item.y + (currentOffset.y - initialOffset.y),
});
